import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthLayout } from "@/components/AuthLayout";
import { TwoFactorCodeForm } from "@/components/TwoFactorCodeForm";
import { useAuth } from "@/lib/auth";
import { completeGoogleSignIn } from "@/lib/google-sso";

export function GoogleSignInCallback() {
  const [params] = useState(() => new URLSearchParams(location.search));
  const [error, setError] = useState("");
  // Google was the first factor; an account with two-step sign-in still needs its code.
  const [challenge, setChallenge] = useState<string | null>(null);
  const { refresh, completeTwoFactor } = useAuth();
  const navigate = useNavigate();
  const destination = import.meta.env.VITE_SCHEDULING_ENABLED==="true"?"/scheduling":"/integrations?setup=calendar";
  useEffect(() => {
    let active = true;
    completeGoogleSignIn(params).then(async (twoStep) => {
      if (!active) return;
      if (twoStep) { setChallenge(twoStep); return; }
      await refresh();
      if (active) navigate(destination, {replace: true});
    }).catch(e => { if (active) setError(e instanceof Error ? e.message : "Sign-in failed."); });
    return () => { active = false; };
  }, [params, refresh, navigate, destination]);
  if (challenge) return <AuthLayout title="Enter your code" subtitle="Open your authenticator app and type the 6-digit code for Bloxx." footer={<Link to="/login" className="underline">Back to sign in</Link>}>
    <TwoFactorCodeForm allowRecovery submitLabel="Sign in" pendingLabel="Signing in…" onCode={async (code) => {
      await completeTwoFactor(challenge, code);
      navigate(destination, {replace: true});
    }} />
  </AuthLayout>;
  return <AuthLayout title="Sign in with Google" subtitle="Connect your account and prepare calendar scheduling." footer={<Link to="/login" className="underline">Back to sign in</Link>}>
    {error ? <p role="alert" className="text-sm text-destructive">{error}</p> : <p role="status">Finishing your Google sign-in…</p>}
  </AuthLayout>;
}
